
// import Menu from './components/Menu.vue'
import axios from 'axios'
export default {
    name: 'LayoutDefault',

    components: {
        // Menu
    },
    methods: {
        async getConfig(){
          var config;
          if(process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'uat'){
            config = "/eservice_portal/config/config.json";
          } else {
            config = "./config/config.json";
          }
          var result = await axios.get(config);
          return result.data;
        },
        getAuth: async function (callbackfunc) {

          var config = await this.getConfig();
          localStorage.setItem("config", JSON.stringify(config) );

          if( !window.location.pathname.includes('bookletpdf') ) {

            if (this.$cookie.get('accessToken') != null || this.$cookie.get('accessToken') != undefined) {
              callbackfunc(null);
              //var tokens = this.$cookie.get('accessToken');
              //console.log("getAuth(): verify start");
              //console.log(window.location.pathname)
              //console.log(tokens);


            } else {
              var host = process.env.VUE_APP_ENV === 'prod' ? config.new_loginBaseUrl_prod : config.new_loginBaseUrl_uat
              var redirect_url = encodeURIComponent((process.env.VUE_APP_ENV === 'prod' ? config.prd_eservice_url : (process.env.VUE_APP_ENV === 'uat' ? config.uat_eservice_url : config.test_BaseUrl)))

              var locationStr = host + '/spa/com/login/int_web.html#redirect_url=' + redirect_url + '&required2fa=0';

              location.href = locationStr;
            }
          }


        },
        callBackAuth: function (authJson) {
            //console.log("callBackAuth(): return authJson = ", authJson);
            this.$store.commit('setAuthJson', authJson);
        }
    },
    created: async function(){
        //await this.getAuth(this.callBackAuth);
    },
    async mounted() {
      //console.log("~~~~START~~~~");
      await this.getAuth(this.callBackAuth);
    },

    data() {
        return {
            leftDrawerOpen: false
        }
    }
}
